import {Injectable} from "@angular/core";
import {IIndustryModel} from "../models/industry";

@Injectable()
export class StaticDataService {

    public industryKey: string = 'melochenator:industry';
    public industryData: Array<IIndustryModel>;

    private static _instance: StaticDataService = new StaticDataService();

    constructor() {
        StaticDataService._instance = this;
    }

    public static getInstance(): StaticDataService {
        return StaticDataService._instance;
    }

    public setData(fields: Array<IIndustryModel>) {
        this.industryData = fields;
        this.store();
    }

    public getData() {
        return this.obtain();
    }

    public store() {
        localStorage.setItem(this.industryKey, JSON.stringify(this.industryData))
    }

    public obtain() {
        return JSON.parse(localStorage.getItem(this.industryKey));
    }

    public remove() {
        localStorage.removeItem(this.industryKey);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/StaticData.service.ts